export const load = () => ({
	title: 'Indow Support for Measurement & Installation',
	showTitle: true,
});
